// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"9e8e95d6","625":"60658363"}[chunkId] + ".chunk.js";
};